import * as React from "react";
import {useStyles} from "./header.styles";

export function Header(props) {
	const {children} = props;
	const classes = useStyles({});

	return (
		<div className={classes.root}>{children}</div>
	);
}

